module.exports = __webpack_public_path__ + "static/img/atlas.74b611f7.jpg";